import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export default function TermsConditionsPage() {
  return (
    <div className="min-h-screen bg-white pb-24 md:pb-12" data-testid="terms-conditions-page">
      <div className="max-w-3xl mx-auto px-4 py-8 md:py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 mb-6">
          <ArrowLeft className="w-4 h-4" />वापस जाएं
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <FileText className="w-8 h-8 text-red-600" />
          <h1 className="font-outfit font-bold text-3xl text-gray-900">नियम और शर्तें / Terms & Conditions</h1>
        </div>
        <p className="text-sm text-gray-500 mb-8">अंतिम अपडेट / Last Updated: 15 April 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">1. स्वीकृति / Acceptance</h2>
            <p>गुमसुदा ऐप/वेबसाइट ("सेवा") का उपयोग करके, आप इन नियमों और शर्तों से सहमत होते हैं। यदि आप इन शर्तों से सहमत नहीं हैं, तो कृपया सेवा का उपयोग न करें।</p>
            <p>By using the Gumsuda app/website ("Service"), you agree to these Terms and Conditions. If you do not agree to these terms, please do not use the Service.</p>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">2. सेवा का विवरण / Service Description</h2>
            <p>गुमसुदा एक सार्वजनिक सेवा पोर्टल है जो:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>लापता व्यक्तियों की रिपोर्ट दर्ज करने और प्रदर्शित करने की सुविधा देता है / Allows filing and displaying reports of missing persons</li>
              <li>अज्ञात व्यक्तियों की जानकारी साझा करता है / Shares information about unidentified persons</li>
              <li>AI-आधारित फेस मैचिंग सेवा प्रदान करता है / Provides AI-based face matching service</li>
              <li>पोस्टर जनरेशन और सोशल मीडिया शेयरिंग सुविधा प्रदान करता है / Provides poster generation and social media sharing facility</li>
            </ul>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">3. उपयोगकर्ता की जिम्मेदारियां / User Responsibilities</h2>
            <p>आप सहमत हैं कि:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>आप केवल सत्य और सटीक जानकारी ही दर्ज करेंगे / You will only submit truthful and accurate information</li>
              <li>आप केवल वास्तविक लापता व्यक्तियों की रिपोर्ट दर्ज करेंगे / You will only report genuinely missing persons</li>
              <li>आप फोटो और व्यक्तिगत जानकारी का दुरुपयोग नहीं करेंगे / You will not misuse photos and personal information</li>
              <li>आप सेवा का उपयोग किसी को परेशान करने, धमकाने या अवैध उद्देश्य के लिए नहीं करेंगे / You will not use the service to harass, threaten, or for any illegal purpose</li>
              <li>आप झूठी रिपोर्ट दर्ज नहीं करेंगे / You will not file false reports</li>
              <li>आपके पास अपलोड की गई फोटो का अधिकार या अनुमति होनी चाहिए / You must have the right or permission for uploaded photos</li>
            </ul>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">4. सामग्री नीति / Content Policy</h2>
            <h3 className="font-semibold text-lg mt-4 mb-2">निषिद्ध सामग्री / Prohibited Content:</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>अश्लील, भद्दी या अनुचित तस्वीरें / Obscene, vulgar or inappropriate images</li>
              <li>झूठी या भ्रामक जानकारी / False or misleading information</li>
              <li>किसी की प्रतिष्ठा को नुकसान पहुंचाने वाली सामग्री / Content that damages someone's reputation</li>
              <li>कॉपीराइट या ट्रेडमार्क उल्लंघन / Copyright or trademark infringement</li>
              <li>घृणा फैलाने वाली या भेदभावपूर्ण सामग्री / Hate speech or discriminatory content</li>
            </ul>
            <p className="mt-2">हम बिना पूर्व सूचना के ऐसी किसी भी सामग्री को हटाने का अधिकार रखते हैं। / We reserve the right to remove any such content without prior notice.</p>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">5. रिपोर्ट अनुमोदन प्रक्रिया / Report Approval Process</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>सभी रिपोर्ट एडमिन द्वारा सत्यापित और अनुमोदित की जाती हैं / All reports are verified and approved by admin</li>
              <li>अनुचित या झूठी रिपोर्ट अस्वीकार की जा सकती है / Inappropriate or false reports may be rejected</li>
              <li>अनुमोदन में समय लग सकता है / Approval may take time</li>
              <li>हम किसी भी रिपोर्ट को बिना कारण बताए अस्वीकार करने का अधिकार रखते हैं / We reserve the right to reject any report without stating reasons</li>
            </ul>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">6. AI फेस मैचिंग सेवा / AI Face Matching Service</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>AI मैचिंग परिणाम 100% सटीक नहीं हो सकते / AI matching results may not be 100% accurate</li>
              <li>यह सेवा केवल सहायता के उद्देश्य से है, अंतिम निर्णय नहीं / This service is for assistance purposes only, not final determination</li>
              <li>किसी भी मैच की पुष्टि संबंधित अधिकारियों से की जानी चाहिए / Any match should be confirmed with relevant authorities</li>
            </ul>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">7. बौद्धिक संपदा / Intellectual Property</h2>
            <p>गुमसुदा का लोगो, डिज़ाइन, कोड और सामग्री हमारी बौद्धिक संपदा है। उपयोगकर्ता द्वारा अपलोड की गई सामग्री पर उपयोगकर्ता का स्वामित्व बना रहता है, लेकिन सेवा के उद्देश्य से उपयोग करने का लाइसेंस हमें प्रदान किया जाता है।</p>
            <p>The Gumsuda logo, design, code, and content are our intellectual property. Users retain ownership of uploaded content but grant us a license to use it for service purposes.</p>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">8. दायित्व की सीमा / Limitation of Liability</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>हम उपयोगकर्ताओं द्वारा दर्ज की गई जानकारी की सत्यता की गारंटी नहीं देते / We do not guarantee the accuracy of user-submitted information</li>
              <li>सेवा "जैसी है" आधार पर प्रदान की जाती है / Service is provided on an "as-is" basis</li>
              <li>हम सेवा के उपयोग से होने वाले किसी भी प्रत्यक्ष या अप्रत्यक्ष नुकसान के लिए जिम्मेदार नहीं हैं / We are not responsible for any direct or indirect damages from use of the service</li>
              <li>हम सेवा की निर्बाध उपलब्धता की गारंटी नहीं देते / We do not guarantee uninterrupted availability of the service</li>
            </ul>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">9. खाता समाप्ति / Account Termination</h2>
            <p>हम निम्नलिखित परिस्थितियों में किसी भी रिपोर्ट या एक्सेस को समाप्त कर सकते हैं:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>नियमों का उल्लंघन / Violation of terms</li>
              <li>झूठी रिपोर्ट दर्ज करना / Filing false reports</li>
              <li>सेवा का दुरुपयोग / Misuse of service</li>
              <li>अवैध गतिविधि / Illegal activity</li>
            </ul>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">10. कानून प्रवर्तन सहयोग / Law Enforcement Cooperation</h2>
            <p>हम कानून प्रवर्तन एजेंसियों के साथ पूर्ण सहयोग करते हैं और वैध कानूनी अनुरोधों पर उपयोगकर्ता डेटा प्रदान कर सकते हैं।</p>
            <p>We fully cooperate with law enforcement agencies and may provide user data upon valid legal requests.</p>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">11. विवाद समाधान / Dispute Resolution</h2>
            <p>इन नियमों से संबंधित किसी भी विवाद को भारतीय कानून के अनुसार और भारतीय न्यायालयों के अधिकार क्षेत्र में सुलझाया जाएगा।</p>
            <p>Any disputes related to these terms shall be resolved according to Indian law and under the jurisdiction of Indian courts.</p>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">12. शर्तों में परिवर्तन / Changes to Terms</h2>
            <p>हम किसी भी समय इन शर्तों को संशोधित कर सकते हैं। संशोधित शर्तें ऐप पर प्रकाशित होने के बाद तुरंत प्रभावी हो जाएंगी। सेवा का निरंतर उपयोग संशोधित शर्तों की स्वीकृति माना जाएगा।</p>
            <p>We may modify these terms at any time. Revised terms become effective immediately upon publication on the app. Continued use of the service constitutes acceptance of revised terms.</p>
          </section>

          <section>
            <h2 className="font-outfit font-bold text-xl text-gray-900 mb-3">13. संपर्क / Contact Us</h2>
            <p>प्रश्नों या शिकायतों के लिए संपर्क करें:</p>
            <ul className="list-none space-y-1">
              <li><strong>ईमेल / Email:</strong> support@gumsuda.com</li>
              <li><strong>वेबसाइट / Website:</strong> https://gumsuda.com</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
